import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-search\"><path d=\"m22 20.9-4.839-4.84a8.573 8.573 0 1 0-1.1 1.101L20.9 22l1.1-1.1ZM3.584 10.587a7.003 7.003 0 1 1 7.003 7.004 7.011 7.011 0 0 1-7.003-7.004Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol